import { render, staticRenderFns } from "./PaidPassengersColumn.vue?vue&type=template&id=6592102e&"
import script from "./PaidPassengersColumn.vue?vue&type=script&lang=js&"
export * from "./PaidPassengersColumn.vue?vue&type=script&lang=js&"
import style0 from "./PaidPassengersColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6592102e')) {
      api.createRecord('6592102e', component.options)
    } else {
      api.reload('6592102e', component.options)
    }
    module.hot.accept("./PaidPassengersColumn.vue?vue&type=template&id=6592102e&", function () {
      api.rerender('6592102e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/PaidPassengersColumn.vue"
export default component.exports